import { render } from "./RecentAncestryNavigation.vue?vue&type=template&id=920e688c"
import script from "./RecentAncestryNavigation.vue?vue&type=script&lang=js"
export * from "./RecentAncestryNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__